import { DaysOfWeek, DaysOfWeekSchedule } from '../../types/booking';

const validateTimes = (times: DaysOfWeekSchedule | {}, timePickerVisibility: DaysOfWeek | {}) => {
  let isValid = true;
  Object.keys(times).forEach((day) => {
    if (timePickerVisibility[day]) {
      if (times && times[day].start >= times[day].end) {
        isValid = false;
      }
    }
  });
  return isValid;
};

export default validateTimes;
